<template>
  <div class="flex items-center gap-2" :class="{ 'w-full': label }">
    <label
      class="relative inline-block w-12 h-6 gd-toggle-switch"
      :class="{ active: value, 'opacity-50 cursor-not-allowed': disabled, 'cursor-pointer': !disabled}"
      @click="toggle"
    >
      <span
        class="absolute inset-0 rounded-full"
        :class="{
          'bg-primary': value,
          [bgClass]: !value,
        }"
      ></span>
    </label>
    <span v-if="label" :class="labelClass || 'text-white'">{{
      label
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'GdToggle',
  props: {
    value: {type: [Boolean, Number], default: false},
    label: {type: String, default: ''},
    labelClass: {type: String, default: ''},
    bgClass: { type: String, default: 'bg-grey-300' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    },
  },
};
</script>
